import { gql } from "@apollo/client";

export const getPromotions = gql`
query GetPromotions(
  $input: GetPromotionsInput
  $countInput: GetPromotionsCountInput
) {
  getPromotions(input: $input) {
    name
    start_datetime
    type
    description
    end_datetime
    id
    createdBy {
      employee_first_name
      employee_last_name
      emp_abbrv
      employee_id
    }
    status
    created_by
  }
  getPromotionsCount(input: $countInput)
}
`

export const getPromotion = gql`
query GetPromotion($getPromotionId: ID) {
  getPromotion(id: $getPromotionId) {
    id
    name
    description
    type
    start_datetime
    end_datetime
    status
    created_by
    auditTrail {
      id
      promotion_id
      actor_id
      actor
      action
      created_at
      updated_at
    }
    assets {
      medium
      large
      small
    }
    createdBy {
      employee_first_name
      employee_last_name
      emp_abbrv
    }
  }
}

`